<template>
  <div :class="['cms', _isMobile() ? 'mobile' : '']">
    <div class="cms-header">
      <h1>{{ courseInfo.courseName }}</h1>
      <div class="cms-info">
        <!-- <span class="gap">发布时间：{{ courseInfo.createTime }}</span> -->
        <span class="gap">浏览次数：{{ courseInfo.viewNum }}次 | {{ courseInfo.courseDesc }}</span>
      </div>
      <a-breadcrumb>
        <!-- <a-breadcrumb-item><a href="/">首页</a></a-breadcrumb-item> -->
        <a-breadcrumb-item><a href="/courseHome">课程首页</a></a-breadcrumb-item>
        <a-breadcrumb-item><a href="/course/list">课程列表</a></a-breadcrumb-item>
        <a-breadcrumb-item>{{courseInfo.courseName}}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <a-divider></a-divider>
    <div class="course-content">
      <a-row type="flex" :gutter="12">
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="course-video">
          <video
            ref="videoPlayer"
            class="video-js vjs-fluid vjs-default-skin vjs-big-play-centered"
          ></video>
          <br>
          <p class="gap">浏览次数：{{ courseInfo.viewNum }}次 | {{ courseInfo.courseDesc }}</p>
          <div v-if="currentMedia.desc">
            <a-divider>视频信息</a-divider>
            
            <pre>{{currentMedia.desc}}</pre>
          </div>
        </a-col>
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <a-tree
            v-if="treeData.length > 0"
            :defaultExpandAll="true"
            :selectedKeys="[currentMedia.key]"
            :tree-data="treeData"
            @select="onSelect"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  data() {
    return {
      courseInfo: {},
      treeData: [],
      src: '',
      currentMedia: {},
      player: null,
      videoOptions: {
        preload: true,
        autoplay: true,
        controls: true, //用户可以与之交互的控件
        loop: false, //视频一结束就重新开始
        muted: false, //默认情况下将使所有音频静音
        // aspectRatio: '16:9', //显示比率
        fullscreen: {
          // options: { navigationUI: 'hide' },
        },
        sources: [{}],
      },
    };
  },
  mounted(){
    // this.initPlayer()
  },
  beforeDestroy() {
    this.player.dispose()
  },
  watch: {
    currentMedia: {
      deep: true,
      handler(newval) {
        console.log(newval);
        window.p = this.player
        this.player.ended()
        this.player.src(newval.path)
        this.player.play()        
      },
    },
    $route(to, from) {
      let courseId = this.$route.query.id;
      this.getCourseInfo(courseId);
      this.getCourseUnitTree(courseId);
    },
  },
  created() {
    let courseId = this.$route.query.id;
    this.getCourseInfo(courseId);
    this.getCourseUnitTree(courseId);
  },
  methods: {
    getCourseInfo(courseId) {
      getAction("/teaching/teachingCourse/get?id=" + courseId).then((res) => {
        this.courseInfo = res.result;
      });
    },
    getCourseUnitTree(courseId) {
      getAction(
        "/teaching/teachingCourseUnit/showCourseUnitTree?courseId=" + courseId
      ).then((res) => {
        this.treeData = res;
        this.initPlayer()
        this.selectFirst()
      });
    },
    initPlayer(){
        this.player = this.$video(this.$refs.videoPlayer, this.videoOptions, function onPlayerReady() {
          this.on('error', function () {
            //this.errorDisplay.close_() //将错误信息不显示
          })
          this.on('canplaythrough', function () {
          })
        })
    },
    selectFirst(){
      if(this.treeData){
        this.currentMedia = this.treeData[0].children[0]
      }
    },
    onSelect(key, e) {
      let media = this.getTreeItem(key[0]);
      if (media) {
        this.currentMedia = media;
      }
      //使课程浏览次数+1
      this.getCourseInfo(this.$route.query.id);
    },
    getTreeItem(key) {
      for (let i in this.treeData) {
        let n1 = this.treeData[i];
        if (n1.children) {
          for (let j in n1.children) {
            if (key == n1.children[j].key) {
              return n1.children[j];
            }
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.cms {
  border-radius: 10px;
  background: white;
  padding: 20px 0;
  margin: 20px 0;
  box-shadow: #c5c0c0 0px 0px 10px;
  min-height: 80vh;
}
.cms-header {
  margin-top: 20px;
  text-align: center;
  h1 {
    margin: 0 50px;
  }
  .cms-info {
    color: gray;
  }
}
.ant-breadcrumb{
  text-align: left;
  margin-left: 10px;
}
.course-content{
  padding: 10px 20px;
  .course-video {
    video {
      width: 100%;
      height: auto;
    }
  }
}


.gap {
  margin-left: 5px;
  margin-right: 20px;
  font-size: 14px;
}

.mobile {
}
</style>